module.exports = __webpack_public_path__ + "img/gb9116_6.prt.410a9c90.jpg";